<div id="print-multiple-reports-parent" class="print-multiple-reports-parent">
  <div class="printMultipleReceipts" *ngFor="let receipt of bulkReceipts">
    <app-print-receipt
      [receiptDetails]="receipt"
      [companyLogo]="companyLogo"
      [shipmentType]="'OnDemand'"
      [user]="user"
      [selectedCustomer]="selectedCustomer"
      [hideStatusCodes]="hideStatusCodes"
      [hideParcelInfo]="hideParcelInfo"
      [hideRating]="hideRating"
      [hideSignature]="hideSignature"
      [hideDestinationAddress]="hideDestinationAddress"
      [hideOriginAddress]="hideOriginAddress"
      [dateTimeFormat]="dateTimeFormat">
    </app-print-receipt>
  </div>
</div>
